import React, { PureComponent } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router';
import { withAuth } from '@jg/auth-react';
import PageCard from '@jg/page-card';
import { PageView } from '@jg/react-tracking';
import {
  getCharity,
  getTeamName,
  getHeroImage,
  getEventName,
  getShortName,
  getMembersListExcludingLinkedFRP,
  getNumberOfMembersFromTeamData,
} from '../../selectors/apiSelectors';
import { IAppState } from '../../types/state.d';
import config from '../../config';
import { makePhotoUrl, makePhotoSquare, withTrack } from '../../utils';
import {
  IYouAreInTheTeam,
  IYouAreInTheTeamMapStateToProps,
} from './YouAreInTheTeam.d';
import { getLocks } from '../../selectors/locksSelectors';

export class YouAreInTheTeam extends PureComponent<IYouAreInTheTeam> {
  onPageCardClick = () => {
    const { track } = this.props;
    track({
      action_name: 'click',
      subtype: 'team page',
      event: 'click',
      event_value: 'team page',
      page_section: 'join team > youre in the team',
    });
  };

  render() {
    const {
      t,
      charityData,
      heroImage,
      teamName,
      auth,
      eventName,
      shortName,
      existingMembersList,
      numberOfMembers,
      teamlocks: { charity: isCharityLocked },
    } = this.props;
    const accessToken = auth.getAccessToken();
    const memberPhoto =
      accessToken &&
      makePhotoUrl(makePhotoSquare(accessToken.profilePictureUrl));
    const myProfile = { picture: memberPhoto, id: '1' };
    const membersList = [...existingMembersList, myProfile]; // TODO to change once the api send us the list of members
    const coverPhoto = makePhotoUrl(heroImage || config.defaultCoverPhoto);

    return (
      <PageView
        trackingData={{
          subtype: 'join team',
          event_value: 'youre in the team',
          page_section: 'join team > youre in the team',
        }}
      >
        <Helmet title={t('title.join.linkedFRP')} />
        <main className="jg-space-pbxl" data-qa="your-in-the-team-page">
          <h1 className="jg-h1 jg-space-ptmd jg-space-mbmd container--heading">
            <Trans i18nKey="content.youareintheteam.heading" />
          </h1>
          <h2 className="jg-h2 jg-space-mbxs">
            <Trans i18nKey="content.youareintheteam.teampage" />
          </h2>
          <PageCard
            coverPhoto={coverPhoto}
            pageName={teamName}
            charityName={
              isCharityLocked
                ? charityData.name
                : t([
                    'content.yourTeamPage.multiCharities',
                    'multiple charities',
                  ])
            }
            usersList={membersList}
            usersNumber={numberOfMembers}
            eventName={eventName}
            fundraisingForLabel={
              <Trans i18nKey="content.yourteampage.fundraisingfor" />
            }
            userLabel={<Trans i18nKey="content.yourteampage.member" />}
            usersLabel={<Trans i18nKey="content.yourteampage.members" />}
            eventLabel={<Trans i18nKey="content.yourteampage.event" />}
            link={`${config.basePageUri}${shortName}`}
            onClick={this.onPageCardClick}
          />
        </main>
      </PageView>
    );
  }
}

export const mapStateToProps = (
  state: IAppState,
): IYouAreInTheTeamMapStateToProps => ({
  teamName: getTeamName(state),
  heroImage: getHeroImage(state),
  charityData: getCharity(state),
  eventName: getEventName(state),
  shortName: getShortName(state),
  existingMembersList: getMembersListExcludingLinkedFRP(state),
  numberOfMembers: getNumberOfMembersFromTeamData(state),
  teamlocks: getLocks(state),
});
export default withTranslation()(
  withAuth(withRouter(connect(mapStateToProps)(withTrack(YouAreInTheTeam)))),
);
